import { FILTERS_SEARCH_SEARCH_REQUEST_CANCELLED, ISearchRequestCancelledAction } from './types';

/**
 * Снимает состояние загрузки, когда запрос за выдачей так и не начался,
 * — иначе прелоадер над страницей останется висеть навсегда.
 */
export function resetLoading(): ISearchRequestCancelledAction {
  return {
    type: FILTERS_SEARCH_SEARCH_REQUEST_CANCELLED,
  };
}
